import { schema, types } from 'papr'

export const userBadgeMapSchema = schema(
	{
		user: types.objectId({ required: true }),
		post: types.objectId(),
		badge: types.objectId({ required: true }),
		metaData: types.any(),
		isActive: types.boolean(),
		assignedOn: types.date(),
		isSuppressed: types.boolean(),
		hiddenFromPublication: types.boolean(),
		actionUrl: types.string(),
	},
	{
		defaults: {
			isActive: true,
			isSuppressed: false,
		},
	},
)

export type UserBadgeMapDocument = (typeof userBadgeMapSchema)[0]
export type UserBadgeMapSchemaOptions = (typeof userBadgeMapSchema)[1]
